/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { MEDIA_TYPES, PROP_NAMES, track } from '@zcode/mixpanel'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelMedia =
  ({ event, pageName, media }) =>
  (dispatch, getState) => {
    if (!media) {
      return
    }
    const state = getState()
    const payload = getCommonProps({ state, pageName })
    const { isIframe, isVideo, isReel } = media
    let mediaType = MEDIA_TYPES.IMAGE
    if (isIframe) {
      mediaType = MEDIA_TYPES.THREE_D
    } else if (isVideo) {
      mediaType = MEDIA_TYPES.VIDEO
    } else if (isReel) {
      mediaType = MEDIA_TYPES.INTERNAL_VIDEO
    }
    payload[PROP_NAMES.MEDIA_TYPE] = mediaType
    track({ event, payload })
  }
